<template>
  <div class="gerenciamento-representante">
    <g-card class="card-gerenciamento-representante" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Liberação de Representante </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza" altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limparFiltro"
            />

            <g-button
            class="plus-button"
            corIconeClass="#FFF"
            cor="#4F2C19"
            altura="35px"
            largura="45px"
            icone="pi pi-plus"
            tamanhoIcone="15px"
            somenteIcone
            @click="abrirPopupNovoVinculo"
            :sombreado="false"
            />

            <g-button
            class="buscar-button-header-filtro"
            largura="150px" icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            @click="getUsuarioRepresentante"
            gap="10px"
            :sombreado="false"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="gerenciamento-representante-conteudo espacamento-filtros">  
          <div class="filtro-nome-usuario">
            <div class="titulo-conteudo-filtros"> Usuário </div>
               <PDropDown
                  v-model="UsuarioRepresentanteViewModel.UsuarioId"
                  :options="UsuarioArray"
                  optionLabel="nomeUsuario"
                  optionValue="id"
                  @filter="buscarUsuario($event.value)"
                  :filter="true"
                  placeholder="Selecione o Usuário"
                />
          </div>           
          <div class="filtro-nome-representante">
            <div class="titulo-conteudo-filtros"> Representante </div>
            <PDropDown
                  v-model="UsuarioRepresentanteViewModel.RepresentanteId"
                  :options="RepresentantesArray"
                  optionLabel="codigoNomeRepresentante"
                  optionValue="representanteId"
                  @filter="buscarRepresentante($event.value)"
                  :filter="true"
                  placeholder="Selecione o Representante"
                />
          </div>
        </div>
      </g-form>
      <PDialog :closable="false" :style="{ width: '50%', margin: '0 5%', minWidth: '300px', maxWidth: '42em' }"
      class="gama-popup" v-if="novoVinculo" v-model:visible="popup">

        <template #header>
          <div class="titulo-formulario"> Adicionar Novo Vinculo</div>
        </template>
        <div>
          <div class="filtro-nome-usuario">
            <div class="titulo-conteudo-filtros"> Usuário </div>
            <PDropDown
                  v-model="UsuarioSelecionado"
                  :options="UsuarioArray"
                  optionLabel="nomeUsuario"
                  optionValue="id"
                  @filter="buscarUsuario($event.value)"
                  :filter="true"
                  placeholder="Selecione o Usuário"
                />
          </div>  
          <div class="filtro-nome-representante">
            <div class="titulo-conteudo-filtros"> Representante </div>
            <PDropDown
                  v-model="RepresentanteSelecionado"
                  :options="RepresentantesArray"
                  optionLabel="codigoNomeRepresentante"
                  optionValue="representanteId"
                  :disabled = "AcessoAdministrador == true"
                  @filter="buscarRepresentante($event.value)"
                  :filter="true"
                  placeholder="Selecione o Representante"
                />
          </div>

          <div class="incentivo-icms input-checkbox">
                  <PCheckBox 
                  id="incentivo-icms" 
                  class="checkbox-incentivo-icms"
                  name="Icms"
                  value="dado"
                  v-model="AcessoAdministrador"
                  :disabled="RepresentanteSelecionado != null"
                  :binary="true"
                  ></PCheckBox>
                  <label class="incentivoIcms label-checkbox" for="incentivo-icms" > Acesso de Administrador </label>
          </div>
        </div>  
        <div class="botoes-popup button-popup">
          <div>
            <g-button tipo="cinza" negritoTexto largura="230px" altura="35px" @click="fechaPopup">
              CANCELAR
            </g-button>
          </div>
          <div>
            <g-button negritoTexto largura="230px" altura="35px" @click="postUsuarioRepresentante">
              CRIAR
            </g-button>
          </div>
        </div>
      </PDialog>

      <PDialog :showHeader="false" :closable="false" :style="{ width: '50%', margin: '0 5%', minWidth: '300px', maxWidth: '42em' }"
      class="popupExcluirStyle" v-model:visible="excluir">

        <div class="grupo-formulario espacamento-filtros">
          <div class="titulo-popup-finalizado"> Deseja excluir esse vinculo de Usuário com Representante? </div>
        </div>

        <div class="botoes-popup button-popup">
          <div>
            <g-button tipo="cinza" negritoTexto largura="230px" altura="35px" @click="fechaPopup">
              NÃO
            </g-button>
          </div>
          <div>
            <g-button negritoTexto largura="230px" altura="35px" @click="excluirUsuarioRepresentante">
              SIM
            </g-button>
          </div>
        </div>
      </PDialog>

      <PDialog :closable="false" :style="{ width: '50%', margin: '0 5%', minWidth: '300px', maxWidth: '42em' }"
      class="gama-popup" v-if="editarVinculo" v-model:visible="popup">

        <template #header>
          <div class="titulo-formulario"> Editar Vinculo</div>
        </template>
        <div>
          <div class="filtro-nome-usuario">
            <div class="titulo-conteudo-filtros"> Usuário </div>
            <PDropDown
                  v-model="UsuarioSelecionado"
                  :options="UsuarioArray"
                  optionLabel="nomeUsuario"
                  optionValue="id"
                  @filter="buscarUsuario($event.value)"
                  :filter="true"
                  disabled
                  placeholder="Selecione o Usuário"
                />
          </div>  
          <div class="filtro-nome-representante">
            <div class="titulo-conteudo-filtros"> Representante </div>
            <PDropDown
                  v-model="RepresentanteSelecionado"
                  :options="RepresentantesArray"
                  optionLabel="codigoNomeRepresentante"
                  optionValue="representanteId"
                  @filter="buscarRepresentante($event.value)"
                  :filter="true"
                  placeholder="Selecione o Representante"
                />
          </div>

          <div class="incentivo-icms input-checkbox">
                  <PCheckBox 
                  id="incentivo-icms" 
                  class="checkbox-incentivo-icms"
                  name="Icms"
                  value="dado"
                  v-model="AcessoAdministrador"
                  :binary="true"
                  ></PCheckBox>
                  <label class="incentivoIcms label-checkbox" for="incentivo-icms" > Acesso de Administrador </label>
          </div>
        </div>  
        <div class="botoes-popup button-popup">
          <div>
            <g-button tipo="cinza" negritoTexto largura="230px" altura="35px" @click="fechaPopup">
              CANCELAR
            </g-button>
          </div>
          <div>
            <g-button negritoTexto largura="230px" altura="35px" @click="postUsuarioRepresentante">
              SALVAR
            </g-button>
          </div>
        </div>
      </PDialog>
      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        @click="getUsuarioRepresentante"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    
    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Usuários Representantes"
      :colunas="Colunas" 
      :valores="infoUsuarioRepresentante"
      Editavel
      Excluivel
      v-on:editar="abrirPopupEdicao"
      v-on:excluir="abrirPopupExcluir"

      >
      </g-data-table>
    </g-card>
  </div>
</template>

<script>
import GerenciamentoRepresentante from "./GerenciamentoRepresentante.js";
export default GerenciamentoRepresentante;
</script>

<style scoped>
.popupExcluirStyle {
  border-radius: 10%;
}
.botoes-popup {
  margin-top:25px;
}
@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-representante-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 22em));
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.filtro-nome-representante { grid-area: 1 / 2 / 2 / 3; }
.filtro-nome-usuario { grid-area: 1 / 1 / 2 / 2;
 }
}

@media (min-width:801px) {
.gerenciamento-representante-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 22em)) auto;
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
